import { createBoundContext } from '@bonusly/ds-utils';

import { AlertSize, AlertStatus } from './types';

export const [AlertContext, useAlertContext] = createBoundContext<{
	size: AlertSize;
	status: AlertStatus;
}>({
	hookName: 'useAlertContext',
	providerName: 'AlertContext',
});
